// Backend codes for Asset Overview statistic widgets, sent and received as-is.
export enum AssetStatisticType {
  COUNT = 'COUNT',
  SUM = 'SUM',
  AVG = 'AVG',
  MIN = 'MIN',
  MAX = 'MAX',
  TOTAL_LENGTH = 'TOTAL_LENGTH',
  TOTAL_AREA = 'TOTAL_AREA',
}

export enum StatisticOperator {
  IS = 'IS',
  IS_NOT = 'IS_NOT',
  CONTAINS = 'CONTAINS',
  GT = 'GT',
  GTE = 'GTE',
  LT = 'LT',
  LTE = 'LTE',
  IS_EMPTY = 'IS_EMPTY',
  IS_NOT_EMPTY = 'IS_NOT_EMPTY',
}

export enum StatisticConnector {
  AND = 'AND',
  OR = 'OR',
}

// Length units for TOTAL_LENGTH, area units for TOTAL_AREA.
export enum StatisticUnit {
  KM = 'KM',
  M = 'M',
  MI = 'MI',
  KM2 = 'KM2',
  HA = 'HA',
  ACRES = 'ACRES',
}
